import { database } from './firebase';

export const fetch = async () => {
  const doc = await database.collection('about').doc('data').get();
  const data = doc.data();
  return data;
};
